export class ShareObject {
  view_key: string;
  wx_key: string;
  share_content: ShareContent;

  constructor(view_key: string, wx_key: string, share_content: ShareContent) {
    this.view_key = view_key;
    this.wx_key = wx_key;
    this.share_content = share_content;
  }
}

export class ShareContent {
  title: string;
  desc: string;
  icon: string;

  constructor(t: string, desc: string, icon: string) {
    this.title = t;
    this.desc = desc;
    this.icon = icon;
  }
}
